import { http } from "./http"
import {
  AgencyTeam,
  GlobalTeam,
  MarketTeam,
} from "routes/Base/Admin/TeamMembers/types"

// ** FETCH **
export const fetchGlobalUsers = async (_key: string) => {
  const res = await http.get("users/global-team").json()
  return res as GlobalTeam[]
}

export const fetchUnassignedUsers = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.get("users/unassigned", { searchParams }).json()
  return res as Partial<GlobalTeam>[]
}

export const fetchAgencyAvailableUsers = async (
  _key: string,
  params?: string,
) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.get("users/planners", { searchParams }).json()
  return res as Partial<AgencyTeam>[]
}

export const fetchMarketUsers = async (_key: string) => {
  const res = await http.get("markets/current/users").json()
  return res as MarketTeam[]
}

// ** CREATE **
export const createMember = async (pld: Partial<MarketTeam>) => {
  const json = pld
  const res = await http.post("markets/current/users", { json }).json()
  return res as MarketTeam
}

// ** EDIT **
export const updateMember = async (
  pld: Partial<MarketTeam> & { userId: string },
) => {
  const { userId, ...json } = pld
  return http.patch(`markets/current/users/${userId}`, { json })
}

// ** DELETE **
export const deleteGlobalUser = async (id: string) =>
  await http.delete(`users/global-team/${id}`)

export const deleteMarketUser = async (id: string) =>
  await http.delete(`markets/current/users/${id}`)
